import { render, staticRenderFns } from "./TrasladoLocDirectoTableComponent.vue?vue&type=template&id=7e750fb8&"
import script from "./TrasladoLocDirectoTableComponent.vue?vue&type=script&lang=js&"
export * from "./TrasladoLocDirectoTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports